import { useEffect, useState } from "react"

export default function useArrayElement<T>(arr: T[], initialIndex = 0) {
  const [index, setIndex] = useState(initialIndex)

  useEffect(() => {
    setIndex(initialIndex)
  }, [arr])

  return [
    arr[index],
    {
      index,
      setIndex,
      next() {
        setIndex((((index + 1) % arr.length) + arr.length) % arr.length)
      },
      prev() {
        setIndex((((index - 1) % arr.length) + arr.length) % arr.length)
      },
    },
  ] as const
}
